import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@izimi/auth';
import { Routes } from 'navigation/types';

export const UnauthenticatedLayout = () => {
  const auth = useAuth();

  if (auth.isAuthenticated) {
    return <Navigate to={Routes.AuthenticationMethodSelection} />;
  }

  return <Outlet />;
};
